/*eslint-disable*/
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import LaunchIcon from "@mui/icons-material/Launch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";

// Composants Matériaux & Navigation
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Routes de navigation
import routes from "routes";

import bgImage from "assets/images/city-profile.jpg";

// Variantes d'animations fluides
const fadeInUp = {
  hidden: { opacity: 0, y: 25 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: [0.25, 0.8, 0.25, 1] },
  },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.08 },
  },
};

function Realisation() {
  const [filter, setFilter] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);

  // Projets Web & Applications
  const projets = [
    {
      id: "kztv",
      titre: "KZ TV",
      category: "web",
      url: "https://kztv.vercel.app",
      apkUrl: "/upload/kztv.apk",
      description:
        "Plateforme de streaming web et lecteur vidéo réactif avec support multi-flux, intégration Chromecast et suivi analytique.",
      image: "https://image.thum.io/get/https://kztv.vercel.app",
      tags: ["React", "TypeScript", "App Mobile", "Chromecast"],
    },
    {
      id: "nrconsult",
      titre: "NR Consult",
      category: "web",
      url: "https://nrconsult.fr",
      description:
        "Site vitrine professionnel conçu pour mettre en avant les services de conseil et d'accompagnement. Design moderne, élégant et responsive.",
      image: "https://image.thum.io/get/https://nrconsult.fr",
      tags: ["React", "UI/UX", "Corporate"],
    },
    {
      id: "taxesconnect",
      titre: "Taxes Connect By NR Consult",
      category: "web",
      url: "https://www.nrfiscmada.com",
      description:
        "Solution numérique de gestion fiscale et administrative permettant de suivre les obligations fiscales et d'accéder aux documents en toute sécurité.",
      image: "https://image.thum.io/get/https://www.nrfiscmada.com/sign-in",
      tags: ["Web App", "Desktop",, "Fintech", "Gestion Fiscale"],
    },
    {
      id: "natioramania",
      titre: "Natiora Mania",
      category: "web",
      url: "https://natioramania.com",
      description:
        "Plateforme dédiée à la commercialisation et l’exportation d’huiles essentielles et d’épices de Madagascar.",
      image: "https://image.thum.io/get/https://natioramania.com",
      tags: ["E-Commerce", "Exportation", "Madagascar"],
    },
    {
      id: "cva",
      titre: "CVA Magasin",
      category: "web",
      url: "https://cva-magasin.vercel.app",
      description:
        "Application e-commerce moderne avec catalogue produits et gestion des commandes.",
      image: "https://image.thum.io/get/https://cva-magasin.vercel.app",
      tags: [ "MERN Stack", "Gestion de Stocks"],
    },
  ];

  // Visuels Graphiques & Branding
  const visuels = Array.from({ length: 10 }, (_, index) => {
    const id = index + 1;
    const isLogo = id === 1 || id === 2;

    return {
      id: `design-${id}`,
      category: isLogo ? "logo" : "design",
      badge: isLogo ? "Logo & Branding" : "Flyer & Visuel",
      image: `/upload/${id}.jpg`,
      isLogo,
      bgColor: id === 2 ? "#1e293b" : isLogo ? "#0f172a" : "#0f172a",
    };
  });

  const filteredProjets = projets.filter(
    (p) => filter === "all" || filter === "web"
  );

  const filteredVisuels = visuels.filter(
    (v) => filter === "all" || filter === v.category
  );

  return (
  <MKBox bgColor="white">
            {/* HERO SECTION */}
            <MKBox
            minHeight="35rem"
            width="100%"
            sx={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "grid",
              placeItems: "center",
            }}
          >
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          style={{ textAlign: "center", padding: "0 20px" }}
        >
          <MKTypography
            variant="h1"
            color="white"
            mb={2}
            sx={{
              fontWeight: 800,
              fontSize: { xs: "2.2rem", sm: "3.2rem", md: "3.8rem" },
              letterSpacing: "-0.02em",
            }}
          >
            Portfolio & Réalisations
          </MKTypography>

          <MKTypography
            variant="h5"
            color="white"
            opacity={0.85}
            maxWidth="650px"
            mx="auto"
            fontWeight="regular"
            sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }}
          >
            Développement Web & Mobile, Ingénierie Géomatique et Design Graphique.
          </MKTypography>
        </motion.div>
      </MKBox>

      {/* CONTENEUR PRINCIPAL */}
      <Card
        sx={{
          p: { xs: 2, sm: 4, md: 5 },
          mx: { xs: 2, lg: 6 },
          mt: -8,
          mb: 4,
          borderRadius: "24px",
          boxShadow: "0 20px 50px rgba(15, 23, 42, 0.06)",
          backgroundColor: "#ffffff",
          border: "1px solid rgba(226, 232, 240, 0.8)",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* BARRE DE FILTRES */}
        <MKBox
          display="flex"
          justifyContent="center"
          gap={{ xs: 1, sm: 1.5 }}
          flexWrap="wrap"
          mb={6}
        >
          {[
            { label: "Tous les projets", value: "all" },
            { label: "Web & Mobile", value: "web" },
            { label: "Logos & Branding", value: "logo" },
            { label: "Flyers & Visuels", value: "design" },
          ].map((btn) => {
            const isActive = filter === btn.value;
            return (
              <MKButton
                key={btn.value}
                variant={isActive ? "gradient" : "outlined"}
                color={isActive ? "info" : "secondary"}
                onClick={() => setFilter(btn.value)}
                sx={{
                  borderRadius: "30px",
                  px: 3,
                  py: 1,
                  textTransform: "capitalize",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  borderColor: isActive ? "transparent" : "#cbd5e1",
                  boxShadow: isActive ? "0 4px 14px rgba(2, 132, 199, 0.25)" : "none",
                  "&:hover": {
                    backgroundColor: isActive ? undefined : "#f8fafc",
                  },
                }}
              >
                {btn.label}
              </MKButton>
            );
          })}
        </MKBox>

        {/* SECTION 1 : PROJETS WEB & APPS */}
        {(filter === "all" || filter === "web") && (
          <MKBox mb={8}>
            <MKTypography variant="h4" mb={0.5} fontWeight="bold" color="dark">
              💻 Applications & Plateformes Web
            </MKTypography>

            <MKTypography variant="body2" color="text" mb={4}>
              Solutions sur-mesure combinant performance, interactivité et UX soignée.
            </MKTypography>

            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
            >
              <Grid container spacing={3.5}>
                {filteredProjets.map((projet) => (
                  <Grid item xs={12} sm={6} md={4} key={projet.id}>
                    <motion.div variants={fadeInUp} style={{ height: "100%" }}>
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "18px",
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
                          transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-6px)",
                            boxShadow: "0 16px 32px rgba(15, 23, 42, 0.12)",
                          },
                        }}
                      >
                        {/* IMAGE DU SITE CLIQUABLE POUR LIGHTBOX */}
                        <MKBox
                          position="relative"
                          overflow="hidden"
                          sx={{
                            cursor: "pointer",
                            "&:hover .zoom-overlay": { opacity: 1 },
                            "&:hover img": { transform: "scale(1.05)" },
                          }}
                          onClick={() => setSelectedImage(projet.image)}
                        >
                          <img
                            src={projet.image}
                            alt={projet.titre}
                            style={{
                              width: "100%",
                              height: "210px",
                              objectFit: "cover",
                              transition: "transform 0.4s ease",
                            }}
                          />
                          <MKBox
                            className="zoom-overlay"
                            position="absolute"
                            top={0}
                            left={0}
                            right={0}
                            bottom={0}
                            sx={{
                              backgroundColor: "rgba(15, 23, 42, 0.4)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              opacity: 0,
                              transition: "opacity 0.3s ease",
                              color: "#fff",
                            }}
                          >
                            <ZoomInIcon sx={{ fontSize: 36 }} />
                          </MKBox>
                        </MKBox>

                        {/* DESCRIPTIF DU PROJET */}
                        <MKBox p={3} display="flex" flexDirection="column" flex={1}>
                          <MKTypography variant="h5" fontWeight="bold" mb={1}>
                            {projet.titre}
                          </MKTypography>

                          <MKTypography
                            variant="body2"
                            color="text"
                            mb={3}
                            sx={{ flexGrow: 1, lineHeight: 1.6, fontSize: "0.9rem" }}
                          >
                            {projet.description}
                          </MKTypography>

                          {/* TAGS */}
                          <MKBox display="flex" gap={0.8} flexWrap="wrap" mb={3}>
                            {projet.tags.map((tag, i) => (
                              <MKBox
                                key={i}
                                component="span"
                                sx={{
                                  backgroundColor: "#f1f5f9",
                                  color: "#334155",
                                  fontSize: "0.72rem",
                                  fontWeight: 600,
                                  px: 1.2,
                                  py: 0.4,
                                  borderRadius: "6px",
                                }}
                              >
                                {tag}
                              </MKBox>
                            ))}
                          </MKBox>

                          {/* BOUTONS D'ACTION */}
                          <MKBox display="flex" gap={1.5} flexWrap="wrap">
                            <MKButton
                              color="info"
                              variant="gradient"
                              href={projet.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                              startIcon={<LaunchIcon />}
                            >
                              Visiter
                            </MKButton>

                            {projet.apkUrl && (
                              <MKButton
                                color="success"
                                variant="outlined"
                                href={projet.apkUrl}
                                download="kztv.apk"
                                size="small"
                                startIcon={<DownloadIcon />}
                              >
                                Télécharger APK
                              </MKButton>
                            )}
                          </MKBox>
                        </MKBox>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </motion.div>
          </MKBox>
        )}

        {/* SECTION 2 : VISUELS GRAPHISMES & LOGOS */}
        {(filter === "all" || filter === "logo" || filter === "design") && (
          <MKBox>
            <MKTypography variant="h4" mb={0.5} fontWeight="bold" color="dark">
              🎨 Design Graphique & Identité Visuelle
            </MKTypography>

            <MKTypography variant="body2" color="text" mb={4}>
              Créations de marque, identités visuelles et supports de communication print/digital.
            </MKTypography>

            <AnimatePresence>
              <Grid container spacing={3}>
                {filteredVisuels.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                    <motion.div
                      layout
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                    >
                      <Card
                        onClick={() => setSelectedImage(item.image)}
                        sx={{
                          cursor: "pointer",
                          borderRadius: "18px",
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                          boxShadow: "0 4px 15px rgba(0,0,0,0.03)",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-6px)",
                            boxShadow: "0 14px 28px rgba(15, 23, 42, 0.12)",
                            "& .zoom-overlay": { opacity: 1 },
                            "& img": { transform: "scale(1.06)" },
                          },
                        }}
                      >
                        <MKBox
                          position="relative"
                          sx={{
                            backgroundColor: item.bgColor,
                            height: "230px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={item.image}
                            alt={item.badge}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: item.isLogo ? "contain" : "cover",
                              padding: item.isLogo ? "24px" : "0px",
                              transition: "transform 0.4s ease",
                            }}
                          />

                          {/* Overlay survol avec loupe */}
                          <MKBox
                            className="zoom-overlay"
                            position="absolute"
                            top={0}
                            left={0}
                            right={0}
                            bottom={0}
                            sx={{
                              backgroundColor: "rgba(15, 23, 42, 0.35)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              opacity: 0,
                              transition: "opacity 0.3s ease",
                              color: "#ffffff",
                            }}
                          >
                            <ZoomInIcon sx={{ fontSize: 32 }} />
                          </MKBox>

                          {/* Badge de catégorie */}
                          <MKBox
                            position="absolute"
                            bottom={12}
                            left={12}
                            sx={{
                              backgroundColor: "rgba(15, 23, 42, 0.75)",
                              backdropFilter: "blur(4px)",
                              color: "#ffffff",
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              px: 1.2,
                              py: 0.4,
                              borderRadius: "20px",
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            {item.badge}
                          </MKBox>
                        </MKBox>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </AnimatePresence>
          </MKBox>
        )}
      </Card>

      {/* LIGHTBOX / MODALE D'AGRANDISSEMENT */}
      <Modal
        open={Boolean(selectedImage)}
        onClose={() => setSelectedImage(null)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(12px)",
          backgroundColor: "rgba(15, 23, 42, 0.8)",
          p: 2,
          zIndex: 1300,
        }}
      >
        <MKBox
          position="relative"
          maxWidth="92vw"
          maxHeight="92vh"
          sx={{
            outline: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Bouton Fermer */}
          <IconButton
            onClick={() => setSelectedImage(null)}
            sx={{
              position: "absolute",
              top: -18,
              right: -18,
              backgroundColor: "#ffffff",
              color: "#0f172a",
              "&:hover": {
                backgroundColor: "#f1f5f9",
              },
              boxShadow: "0 6px 20px rgba(0,0,0,0.3)",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Image Agrandie */}
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Aperçu grand format"
              style={{
                maxWidth: "100%",
                maxHeight: "85vh",
                borderRadius: "16px",
                objectFit: "contain",
                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
              }}
            />
          )}
        </MKBox>
      </Modal>
    </MKBox>
  );
}

export default Realisation;
